module.exports = __webpack_public_path__ + "img/logo-ob.44f228ac.png";